import React from 'react'
import { FullDescription } from './DetailedInfo/FullDescription'
import { RelatedPosts } from './DetailedInfo/RelatedPosts'
import { RelatedProducts } from './DetailedInfo/RelatedProducts'

export const DetailedInfoContainer = () => {
  return (
    <section className="section-name py-5 bg">
      <div className="container">
        <div className="row">
          <FullDescription />
          <aside className="col-md-4">
            <div className="mb-2">
              <RelatedProducts />
            </div>
            <div className="mb-2">
              <RelatedPosts />
            </div>
          </aside>
        </div>
      </div>
    </section>
  )
}
